import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Button } from "@/components/ui/button";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookie_consent");
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookie_consent", "true", { expires: 365 });
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-zinc-950 border-t border-white/10 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]">
      <div className="container mx-auto max-w-5xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-slate-300">
          <p>
            Utilizamos cookies essenciais para melhorar sua experiência em nosso site e garantir que o agendamento funcione corretamente. 
            Ao continuar navegando, você concorda com nossa <a href="/#/privacidade" className="text-primary hover:underline font-bold">Política de Privacidade</a>.
          </p>
        </div>
        <div className="flex shrink-0 w-full sm:w-auto">
          <Button 
            onClick={handleAccept}
            className="w-full sm:w-auto bg-primary text-white font-black uppercase tracking-widest hover:scale-105 transition-all"
          >
            Entendi e Aceito
          </Button>
        </div>
      </div>
    </div>
  );
}
